import { z } from "zod"
import { apiResponseSchema, paginatedResponseSchema } from "./shared"

const businessSummarySchema = z
  .object({
    _id: z.string(),
    name: z.string().optional(),
    image: z.string().optional(),
    location: z.string().optional(),
    parentBusiness: z.string().nullish(),
  })
  .passthrough()

export const businessContextsSchema = z
  .object({
    owned: z.array(businessSummarySchema),
    providerFor: z.array(businessSummarySchema),
    adminFor: z.array(businessSummarySchema),
    isCustomer: z.boolean(),
  })
  .passthrough()

export const platformContextsSchema = z
  .object({
    roles: z.array(z.string()),
  })
  .passthrough()

export const businessRefSchema = z
  .object({
    _id: z.string(),
    name: z.string().optional(),
    image: z.string().optional(),
    industry: z
      .array(
        z.union([
          z.string(),
          z
            .object({
              name: z.string().optional(),
            })
            .passthrough(),
        ])
      )
      .optional(),
    description: z.string().optional(),
    receivingAccount: z
      .object({
        account_number: z.string().optional(),
      })
      .optional(),
  })
  .passthrough()

export const userSchema = z
  .object({
    _id: z.union([z.string(), z.number()]).optional(),
    name: z.string().nullable().optional(),
    email: z.string().nullable().optional(),
    phoneNumber: z.union([z.string(), z.number()]).nullable().optional(),
    username: z.string().nullable().optional(),
    image: z.string().nullable().optional(),
    userType: z
      .union([z.string(), z.array(z.string())])
      .nullable()
      .optional(),
    businesses: z.array(businessRefSchema).optional(),
    businessContexts: businessContextsSchema.optional(),
    platformContexts: platformContextsSchema.optional(),
    eligibleConsoleScopes: z.array(z.enum(["PLATFORM", "TENANT"])).optional(),
    consoleLandingScope: z.enum(["PLATFORM", "TENANT"]).optional(),
    lastActiveBusinessId: z.string().optional(),
    locale: z.enum(["en", "fr", "es"]).optional(),
    providerBusinessIds: z.array(z.string()).optional(),
    serviceTracks: z.array(z.unknown()).optional(),
  })
  .passthrough()

export const userResponseSchema = z.union([
  apiResponseSchema(userSchema),
  userSchema,
])
export const usersListResponseSchema = paginatedResponseSchema(userSchema)
